"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HousesStatistic = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./HousesStatistic.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const HousesStatistic = props => {
  const {
    deadlineViolationsPercent
  } = props;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['data']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['text']
  }, props.housesDeadlineText), /*#__PURE__*/React.createElement("div", null, props.completedHouses)), /*#__PURE__*/React.createElement("i", {
    className: styles['percent-bar'],
    style: {
      background: `linear-gradient(to right, #34ac0a ${100 - deadlineViolationsPercent}%, #db6f0a ${100 - deadlineViolationsPercent}%  ${deadlineViolationsPercent}%`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['percent']
  }, deadlineViolationsPercent, "% \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u043E\u0432"));
};
exports.HousesStatistic = HousesStatistic;